import { render, staticRenderFns } from "./ClientPagoProveedoresReport.vue?vue&type=template&id=643c7283&scoped=true&"
import script from "./ClientPagoProveedoresReport.vue?vue&type=script&lang=js&"
export * from "./ClientPagoProveedoresReport.vue?vue&type=script&lang=js&"
import style0 from "./ClientPagoProveedoresReport.vue?vue&type=style&index=0&id=643c7283&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c7283",
  null
  
)

export default component.exports